import { SelectEquipmentProducts } from './SelectEquipment';
import { SelectIspPartner } from './SelectIspPartner';
import { SelectPremiumProducts } from './SelectPremiums';
import { SummaryV2 } from './SummaryV2';
import { VerificationAndCustomerInfo } from './VerificationAndCustomerInfo';

export const SelectPremiums: React.FC = () => <SelectPremiumProducts />;

export const SelectEquipment: React.FC = () => <SelectEquipmentProducts />;

export const SelectISP: React.FC = () => <SelectIspPartner />;

export const VerificationAndContactInfo: React.FC = () => <VerificationAndCustomerInfo />;

export const Summary: React.FC = () => <SummaryV2 />;
